import PropTypes from 'prop-types';
import React from 'react';
import ArchivesDayNav from './archives_day_nav';
import ArchivesYearNav from './archives_year_nav';
import {isNumber} from 'lodash';

const shouldRenderArchivesDayNav = ({ day }) => isNumber(day);

const ArchivesInterface = ({ timestamp, ...props }) => (
  <div id="archives-footer-nav">
    {
      shouldRenderArchivesDayNav(props)
      && <ArchivesDayNav timestamp={timestamp} />
    }
    <ArchivesYearNav />
  </div>
);

ArchivesInterface.propTypes = {
  timestamp: PropTypes.number,
  day: PropTypes.number
};

export default ArchivesInterface;
